// extracted by css-extract-rspack-plugin
export default {"timelineEventList":"RMQcF","timelineEventDate":"OCK5X"};